import { render, staticRenderFns } from "./AddUpcomingClassesModal.vue?vue&type=template&id=78541a04&"
import script from "./AddUpcomingClassesModal.vue?vue&type=script&lang=js&"
export * from "./AddUpcomingClassesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports